import grispiApi from '../../../apis/grispiApi';
import { IMacro } from '../../../hooks/macrosPage/useMacroList';
import { fetcherWithToken } from '../../../utils/fetchers';

export const getActiveMacroList = async (): Promise<IMacro[]> => {
    const activeMacroList = await fetcherWithToken('/macros?active');
    return activeMacroList;
};

export const createMacro = async (createMacroPostData: Omit<IMacro, 'id'>): Promise<void> => {
    await grispiApi.post('/macros', createMacroPostData);
};

export const updateMacro = async (updateMacroPostData: IMacro): Promise<void> => {
    const { id, ...rest } = updateMacroPostData;
    await grispiApi.put(`/macros/${id}`, rest);
};

export const deleteMacro = async (macroId: number): Promise<void> => {
    await grispiApi.delete(`/macros/${macroId}`);
};

export const enableMacro = async (macroId: number): Promise<void> => {
    await grispiApi.delete(`/macros/${macroId}/activation`);
};

export const disableMacro = async (macroId: number): Promise<void> => {
    await grispiApi.post(`/macros/${macroId}/activation`);
};
